// extracted by mini-css-extract-plugin
module.exports = {"root":"custom-chip_root__3KHcS","icon":"custom-chip_icon__3Tl87"};